import pixNProgress from '../shared/pixNProgress.js';
import store from '../store/index.js';

/**
 * This guard prevents the loading of the personas detail component when the user does not have authorization.
 */
const pixPersonasDetailGuard = async (to, from, next) => {
  await store.dispatch('personasModule/setPersonasRowId', to.params.rowUserId);
  await store.dispatch('personasModule/setPersonasDetail');
  if (store.getters['personasModule/getPersonaDetail']) {
    next();
  } else {
    pixNProgress.forceFinish();
    store.dispatch('toastModule/error', 'Unauthorized');
    next(false);
  }
};

export default pixPersonasDetailGuard;
